import React from "react";
import { MessageCircle } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function FloatingWhatsApp() {
  const { config } = useSite();
  const number = config?.whatsapp || "5543999601156";
  const text = encodeURIComponent("Olá! Cheguei pelo site da DeskcodeBR e gostaria de mais informações.");
  const href = `https://wa.me/${number}?text=${text}`;

  return (
    <a
      data-testid="floating-whatsapp"
      href={href}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="Falar no WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30"></span>
      <span className="relative flex items-center gap-3 bg-[#25D366] hover:bg-[#1fb557] text-white pl-4 pr-5 py-4 rounded-full shadow-2xl shadow-[#25D366]/30 transition-all hover:scale-105">
        <MessageCircle className="w-6 h-6" strokeWidth={2} />
        <span className="hidden md:inline text-sm font-semibold">Fale conosco</span>
      </span>
    </a>
  );
}
